/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { orderBy } from "lodash";
import Draggable from 'react-draggable'; // The default


import { Button, InputLabel, TextField } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import Autocomplete from '@mui/material/Autocomplete';
import { clearSessionStorage, Loadable } from '../../../../common';
import { useSelector } from "react-redux";
import KTOffcanvas from "../../../../../_metronic/_assets/js/offcanvas";
import { RootState } from "../../../../store/reducers";
import { getClientProductsById } from "../../../../store/api/clients";
import { useTableFilter } from "../../../../common";

const useStyles1 = makeStyles(theme => ({
  button: {
    marginTop: 10
  },
  input: {
    display: "none"
  },
  toolbar: {
    border: '1px solid rgba(224, 224, 224, 1)',
    zIndex: 100,
    // marginTop: "30px"
  },
  dockTop:{
    top:0,
    border:"none",
    background:"none"
  }
}));

// Will be used for client switch
const clientSwitchParentRoutes = [
    "/dashboard", //Dashboard
    "/admin/clients", //Client
    "/admin/dashboards", //Admin Dashboard
    "/admin/users", //Users
    "/admin/roles", //Roles
    "/admin/partners", //Partners
    "/admin/api-key-management", //API Keys
    "/admin/credits-usage", //Credit Usage
    "/admin/creditsusage-report", //Credit Usage Report
    "/admin/ai/prompt-management", //AI Prompt Management
    "/cms/supplementary-prompts", //Supplementary Prompts
    "/admin/app-id-management", //API Management
    "/cms/confidence-score-triage", //Confidence Score
    "/cms/charge-analysis", //Charge Analysis
    "/admin/claimAudits", //Claim Audit
    "/changepassword", //Change Password
    "/admin/statistics/trim", //Statistics
    "/cms/feeschedules", //Fee Schedule
    "/pricer/executions", //Pricer Executions
    "/cms/global-feeschedules", //Global Fee Schedule
    "/cms/contracts", //Contracts
    "/cms/rcm-status", //RCM Status
    "/cms/codeservice", //Code Service
    "/configuration-settings", //Configuration Settings
    "/configuration-branding/branding", //Configuration Branding
    "/cms/facilities", //Facility
    "/cms/criteria", //Search Criteria
    "/cms/provider-roles", //Provider Roles
    "/cms/modifiers", //Modifiers
    "/cms/ipps", //IPPS
    "/cms/opps", //OPPS
    "/cms/family", //Contract Family
    "/notification-subscriptions", //Notification Subscription
    "/all-notifications", //All Notifications
    "/cms/claimAnalysis", //Claim Analysis
    "/cms/modeling", //Claim Modelling,
    "/cms/claimLookup", //Claim Lookup
    "/cms/supplemental-files", //Claim Payer Mapping,
    "/cms/summary-dashboard", //Summary Dashboard
    "/cms/simulator", //Simulator
    "/cms/new-simulator", //New Simulator
    "/estimator/history", //Estimator History
    "/estimator/chargeMaster", //Charge Master
    "/estimator/associated", //Associated Charge
    "/estimator/payeridmapping", //PayerId Mapping
    "/cms/payers/contracts", //Payer contract
    "/cms/payers/scorecard", //Payer Scorecard
    "/cms/payers/payerinfo", //Payer Info
    "/cms/payers/remitPayers", //Remit Payers
    "/cms/payers/planManagement", //Plan management
    "/cms/executions", //Analysis Executions
    "/pricer/chargeMaster", //Pricer Charge Master
    "/pricer/shoppable", //Pricer Shoppable
    "/pricer/associated", //Pricer Associated
    "/pricer/allowables", //Pricer Allowables
    "/pricer/brandconfiguration", //Pricer Brand Configuration
    "/pricer/payer-setup", //Pricer Payer Setup
    "/pricer/payerInfo", //Pricer PayerInfo
    "/pricer/claim-payers", //Pricer Claim Payers
    "/pricer/configuration", //Pricer Configuration
    "/pricer/hospitalservices", //Pricer Hospital Service
    "/pricer/modifiers", //Pricer Modifiers
    "/pricer/progress", //Pricer Progress
    "/pricer/edi-executions", //Pricer Edi Execution
    "/vendor", //Vendor
    "/file-management/uploads", //File Management Upload
    "/file-management/fileExecutions", //File Executions
    "/unauthorized", //Unauthorized
    "/fallback-page", //Fallback Page
    "/controlRoom/jobStatistics", //Job Statistics
    "/controlRoom/s3Listners", //S3Listners
    "/controlRoom/qs-dataset", //QS Dataset
    "/controlRoom/healthCheck", //Health Check
    "/about/version", //About
    "/cms/eapg", //EAPG
    "/cms/claimstatuses", //Claim Status
    "/cms/rcm-assignment", //RCM Assignment
    "/admin/audit-logs", //Audit Logs
    "/admin/partner-ip-mask", //Partner IP Mask
    "/admin/provider-data", //Provider Data
    "/cms/providers", //Providers
    "/cms/contract/contractedrates",
    "/cms/claimAudits",
];

const childParentMapping = {
    "/cms/feeschedulesrate": "/cms/feeschedules",
    "/cms/contract": "/cms/contracts",
    "/cms/facilities/account-consolidation": "/cms/facilities",
    "/cms/contract/rule": "/cms/contracts",
    "/admin/clients/configuration": "/admin/clients",
};

export default function SwitchClient({
    history,
    clients,
    loading,
    isSuperAdmin,
    isPartner,
    isPartnerUser,
    selectedClient:currentSelectedClient,
    configuration,
    products,
    actions: {
        clientListTiny,
        switchClient,
        resetPageFilter,
        resetPricerFilter,
        getClientProducts,
        resetSearchCriteria,
        setUnreadCount,
        getSettings,
        getConfiguration,
        updatePreferredDashboardClientId
    },
}) {
    const classes = useStyles1();
    const [clientId, setClientId] = React.useState(null);
    const [isClientInactive, setClientInactive] = React.useState(false);
    const [sidebar, setSidebar] = React.useState(null);
    const [isPanelOpen, setPanelOpen] = React.useState(false);
    let [activeDrags, setActiveDrags] = React.useState(0);  
    const userPrivileges:{partnerClientIds?:number[],role?:string,clientId?:number | string} = useSelector<RootState>( state => state?.session?.user );    

    React.useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
            clientListTiny(); //fetch client list
        const panel = document.getElementById("switch_client_kt_quick_panel"); //setting up sidebar
        // eslint-disable-next-line
        const offCanvas = new KTOffcanvas(panel, {
            overlay: true,
            baseClass: "kt-quick-panel",
            closeBy: "switch_client_kt_quick_panel_close_btn",
            toggleBy: "switch_client_kt_quick_panel_toggler_btn",
            setPanelOpen: setPanelOpen,
        });
        setSidebar(offCanvas);

        const selectedClient = clients.find(
            (client) => client.clientId === currentSelectedClient
        );
        
        if (selectedClient) {
            if (!selectedClient.active) {
                setClientInactive(true);
                document
                    .getElementById("switch_client_kt_quick_panel_toggler_btn")
                    .click();
                setPanelOpen(true);
            } else {
                setClientInactive(false);
            }
            setClientId(selectedClient);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clients.length]);

    const resetAllConfigurationsAndData = () => {
        localStorage.removeItem("isCriteriaCleared");
        sessionStorage.removeItem("pages");

        // Clear all session storage items that start with "page-state:"
        clearSessionStorage( 'page-state' );

        sessionStorage.removeItem("duplicated");
        resetSearchCriteria();
    }

    const handleClick = async (event) => {
        if (clientId) {
            let clientProducts = {};
            if (isPartner || isPartnerUser) {
               clientProducts = await getClientProductsById(clientId.clientId);
            }
            const currentPath = history.location.pathname;
            switchClient(clientId.clientId,()=> closeSidebar(currentPath,clientId.clientId,clientProducts??[])); // Update state locally and remotely
            resetPageFilter();
            resetPricerFilter();
        }
        resetAllConfigurationsAndData()
    };

    const getParentPath = (pathname: string) => {
        if (!pathname) return null;
        const segments = pathname.split("/").filter(Boolean);
        if (segments.length === 0) return null;
        const isId = (seg: string) => /^\d+$/.test(seg);
        const ACTION_SEGMENTS = [
            "edit",
            "view",
            "create",
            "details",
            "update",
            "claimappeal",
            "data-view",
            "ai-chats-history",
            "ai-chat",
            "results",
            "copy",
            "root"
        ];        

        const cleaned: string[] = [];

        for (const seg of segments) {
            const lower = seg.toLowerCase();

            if (ACTION_SEGMENTS.includes(lower)) break; // stop at edit/view
            if (isId(seg)) continue; // skip numeric IDs

            cleaned.push(seg);
        }

        if (!cleaned.length) return null;
        let newPath = "/" + cleaned.join("/");
        if (
            !clientSwitchParentRoutes.includes(newPath)
        ) {
            if(childParentMapping[newPath]){
                newPath = childParentMapping[newPath];
            }
            else{
                newPath = clientSwitchParentRoutes[0];
            }
        }
        return newPath;
    }

    const closeSidebar = (url=undefined,clientId=undefined,products=undefined) => {
        getSettings()
        setPanelOpen(false);
        setClientInactive(false);
        setUnreadCount(null)
        sidebar.hide();        
        let autoParent = getParentPath(url);        
        const userProducts = products;
       
        if (isPartnerUser || isPartner) {
            const hasAccess = isPathAllowed(autoParent, userProducts);
            
            if (!hasAccess || autoParent === "/unauthorized") {
                const fallbackRoute = Object.entries(permissionRouteMap).find(
                    ([permissionKey, routes]) =>
                        userProducts[permissionKey] && routes.length > 0
                )?.[1][0];
                
            const newPath = fallbackRoute.split('/').filter(Boolean);
            autoParent =  (newPath.length == 1) ? defaultPath[newPath[0]] :   fallbackRoute  ;
            }
        }
        
        window.location.href = window.location.origin+(autoParent || "/");
        if(!clientId) return
        updatePreferredDashboardClientId(clientId);
        getConfiguration(clientId,isSuperAdmin)
    };

    type ClientPermissions = {
        hasCMSAccess: boolean;
        hasCMSRCMStatusReportAccess: boolean;
        hasDashboardAccess: boolean;
        hasEstimatorAccess: boolean;
        hasPricerAccess: boolean;
        hasVendorManagementAccess: boolean;
    };

    const permissionRouteMap: Record<string, string[]> = {
        hasDashboardAccess: ["/dashboard"],
        hasCMSAccess: ["/cms"],
        hasCMSRCMStatusReportAccess: ["/cms/rcm-status"],
        hasEstimatorAccess: ["/estimator"],
        hasPricerAccess: ["/pricer"],
        hasVendorManagementAccess: ["/vendor"]
    };

    // Routes without Permissions
    const CommonRoutes = [
        "/notification-subscriptions",
        "/all-notifications",
        "/about/version",
        "/file-management/uploads",
        "/file-management/fileexecutions",
        "/configuration-branding/branding",
        "/configuration-settings",
        "/admin/users",
        "/admin/creditsusage-report",
        "/admin/statistics/trim",
        "/changepassword" 
    ];
    
    const defaultPath = {
        cms : "/cms/claimAnalysis",
        dashboard:"/dashboard",
        estimator:"/estimator/history",
        pricer:"/pricer/brandConfiguration",
        vendor:"/vendor",
        cmsrcmstatus:"/cms/rcm-status"
    }

    function isPathAllowed(path: string, permissions: ClientPermissions): boolean {
        if (!path) return false;
            const cleanPath = path.replace(/\/+$/, "").toLowerCase();

        return (
            Object.entries(permissionRouteMap).some(([permissionKey, routes]) =>
                permissions[permissionKey as keyof ClientPermissions] &&
                routes.some(route => cleanPath.startsWith(route.toLowerCase()))
            )
            ||
            CommonRoutes.some(route =>
                cleanPath.startsWith(route.toLowerCase())
            )
        );
    }

    const handleSideBarClose = () => {
        sidebar.hide();
        setPanelOpen(false);
    };

    const onStart = () => {
        setActiveDrags(++activeDrags);
    };

    const onStop = () => {
        setActiveDrags(--activeDrags);
    };

    const dragHandlers = { onStart: onStart, onStop: onStop };

    React.useEffect(() => {
        // If preferredDashboard param exists, switch client; if already on it, go to claim analysis with assigned user.
        const queryParams = new URLSearchParams(window.location.search);
        const clientSwitchIdRequestedByUser:string = queryParams.get(
            "preferredDashboardClientId"
        );
        const assignedTo = queryParams.get("assignedTo");        
        if (
            clients?.length &&
            clientSwitchIdRequestedByUser &&
            clientId?.clientId &&
            clientId?.clientId != clientSwitchIdRequestedByUser
        ) {
             const invalidClient =
                 clients.filter(
                     (client) =>
                         client?.clientId == clientSwitchIdRequestedByUser &&  client?.active
                 )?.length === 0;
            
             if (
                 (!isSuperAdmin &&
                     userPrivileges?.partnerClientIds.includes(
                         parseInt(clientSwitchIdRequestedByUser)
                     ) === false) ||
                 (isSuperAdmin && invalidClient)
             ) {
                 // partneruser or partner trying to access the client they don't have acess to
                 history.push("/error");
                 return;
             }
            switchClient(queryParams.get("preferredDashboardClientId"), () =>
                closeSidebar(
                    `${history.location.pathname}?assignedTo=${assignedTo}`
                )
            ); // Update state locally and remotely
            resetPageFilter();
            setClientId(
                clients?.find(
                    (item) => item?.clientId == clientSwitchIdRequestedByUser
                )
            );
            resetPricerFilter();
            clientListTiny();
            resetAllConfigurationsAndData();
        }
        if (clientSwitchIdRequestedByUser &&
            clientId?.clientId &&
            clientId?.clientId == clientSwitchIdRequestedByUser
        ) {
            history.push(
                `${history.location.pathname}?assignedTo=${assignedTo}`
            );
        }
        if((userPrivileges?.role==="user" || userPrivileges?.role==="administrator") && clientSwitchIdRequestedByUser)
        {
            if(clientSwitchIdRequestedByUser==userPrivileges?.clientId)
            {
                history.push(
                `${history.location.pathname}?assignedTo=${assignedTo}`
            );
            }
            else{
                {
                 history.push("/error");
                 return
             }
            }
        }
    }, [history, clientId, clients]);

    return (<>
        {isPanelOpen && (
            <div
                onClick={isClientInactive ? undefined : handleSideBarClose}
                className="kt-quick-panel-overlay"
            ></div>
        )}
        <React.Fragment key={"right"}>
            <div
                style={{ padding: "2.5rem" }}
                id="switch_client_kt_quick_panel"
                className="kt-quick-panel"
            >
                    <a
                        href="#"
                        className="kt-quick-panel__close"
                        id="switch_client_kt_quick_panel_close_btn"
                        onClick={handleSideBarClose}
                    >
                        <i className="flaticon2-delete" />
                    </a>
                <Loadable loading={loading}>
                    <div className="kt-quick-panel__content">
                        {isClientInactive && (
                            <div className="text-danger pb-4">
                                <b>
                                    Selected Client is deactivated. Please
                                    switch to another client to use the
                                    application.
                                </b>
                            </div>
                        )}
                        <React.Fragment>
                            <InputLabel htmlFor="client">Client</InputLabel>
                            <Autocomplete
                                onChange={(event, newValue) => {
                                    setClientId(newValue);
                                }}
                                value={clientId}
                                getOptionDisabled={(option) =>
                                    !option.active
                                }
                                options={orderBy(clients?.filter((item)=>item?.active), ["name"])}
                                getOptionLabel={(option) =>
                                    option.name ? option.name : ""
                                }
                                isOptionEqualToValue={(option, value) =>
                                    value.name === option.name
                                }
                                renderInput={(params) => (
                                    <TextField {...params} fullWidth />
                                )}
                                renderOption={(props, option) => (
                                    <li {...props} key={option.clientId}>
                                        {option.name}
                                    </li>
                                )}
                            />
                        </React.Fragment>
                        <Button
                            disabled={
                                isClientInactive &&
                                currentSelectedClient === clientId?.clientId
                            }
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            onClick={handleClick}
                        >
                            Change
                        </Button>
                    </div>
                </Loadable>
            </div>
        </React.Fragment>
        {(isSuperAdmin || isPartner || isPartnerUser) && (
            // <Draggable axis="y" {...dragHandlers}>
                <ul className={`${classes.toolbar} kt-sticky-toolbar ${classes.dockTop}`} >
                    <OverlayTrigger
                        placement="left"
                        overlay={
                            <Tooltip id="documentations-tooltip">
                                Switch Account
                            </Tooltip>
                        }
                    >
                        <li
                            className="kt-sticky-toolbar__item kt-sticky-toolbar__item--warning"
                            data-placement="left"
                        >
                            <a
                                id="switch_client_kt_quick_panel_toggler_btn"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="flaticon2-gear" />
                            </a>
                        </li>
                    </OverlayTrigger>
                </ul>
            //  </Draggable>
        )}
    </>);
}
